import React, { useState } from 'react';

interface ProductImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  placeholder?: React.ReactNode;
}

const defaultPlaceholder = (
  <div
    style={{
      width: 89,
      height: 99,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f7f7f7',
      borderRadius: 4,
    }}
  >
    <span style={{ color: '#bbb', fontSize: 12 }}>Loading...</span>
  </div>
);

export const ProductImage = ({
  src,
  alt,
  style,
  className,
  placeholder = defaultPlaceholder,
  ...rest
}: ProductImageProps) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <>
      {!isLoaded && placeholder}
      <img
        src={src}
        alt={alt}
        style={{
          display: isLoaded ? 'block' : 'none',
          objectFit: 'cover',
          borderRadius: 4,
          maxHeight: '99px',
          ...style,
        }}
        className={className}
        onLoad={() => setIsLoaded(true)}
        onError={() => setIsLoaded(true)}
        {...rest}
      />
    </>
  );
};

export default ProductImage;
